import { useState } from "react";
import { faqItems } from "@/mocks/site";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.6fr] lg:gap-12">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问答</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于收录范围、内容性质、更新频率和筛选方式，这里一次说明白。
            </p>
          </div>

          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100/50">
            {faqItems.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div key={faq.id}>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? "" : faq.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-primary-50/60"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center text-accent-600">
                        <i className="ri-question-line text-base" aria-hidden="true" />
                      </span>
                      <span className="font-medium text-foreground-900">{faq.question}</span>
                    </span>
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-500">
                      <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true" />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[3.25rem] text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}